import { MODE } from 'src/config';

export const print = (...msg) => {
  if (MODE === 'development') {
    console.log(...msg);
  }
};
